import React from 'react';

interface WordNotFoundModalProps {
  word: string;
  wordLength: number;
  useUmlauts: boolean;
  onAdd: () => void;
  onClose: () => void;
}

const WordNotFoundModal: React.FC<WordNotFoundModalProps> = ({
  word,
  wordLength,
  useUmlauts,
  onAdd,
  onClose
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-6 max-w-md w-full">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Wort nicht gefunden</h2>
        <p className="text-gray-600 mb-2">
          Das Wort <span className="font-semibold">{word.toUpperCase()}</span> ist nicht in der Wörterliste enthalten.
        </p>
        <p className="text-gray-600 mb-6">
          Möchtest du dieses Wort zu deiner persönlichen Wörterliste hinzufügen?
        </p>
        <div className="flex gap-4">
          <button
            onClick={onAdd}
            className="flex-1 bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-6 rounded-lg transition duration-200"
          >
            Zur Liste hinzufügen
          </button>
          <button
            onClick={onClose}
            className="flex-1 bg-gray-600 hover:bg-gray-700 text-white font-semibold py-3 px-6 rounded-lg transition duration-200"
          >
            Abbrechen
          </button>
        </div>
      </div>
    </div>
  );
};

export default WordNotFoundModal;

